import * as service from './service';

const entity = {
  state: {
    list: [],
    listGlobalCount: 0
  },
  reducers: {
    listUpdated(state, payload) {
      return {
        ...state,
        list: payload.rows || payload,
        listGlobalCount: payload.count || payload.length
      };
    }
  },
  effects: {
    async getEntities(criteria) {
      const list = await service.getEntities(criteria);
      if (list) this.listUpdated(list);
      return list;
    },
    getEntity: service.getEntity,
    createEntity: service.createEntity,
    updateEntity: service.updateEntity,
    deleteEntity: service.deleteEntity
  }
};

export default entity;
